import React from "react";
import { GitHubCalendar } from "react-github-calendar";
import { Row } from "react-bootstrap";

function Github() {
  return (
    <Row className="about-github-row">
      <h2 className="about-block-heading">
        Days I <strong className="purple">Code</strong>
      </h2>
      <GitHubCalendar
        username="amitha511"
        blockSize={15}
        blockMargin={5}
        color="#c084f5"
        fontSize={16}
      />
    </Row>
  );
}

export default Github;
